import React, { Component } from 'react'
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

export default class Footter extends Component {
    render() {
        return (
            <>
                 <MDBFooter color="orange" className="font-small pt-4 ">
      <MDBContainer fluid className="text-center text-md-left">
        <MDBRow>
          <MDBCol md="12">
            <h5 className="title"> Kamphaeng Phet Rajabhat University Professional Standards Framework</h5>
            <p>
              การพัฒนาคุณภาพอาจารย์เพื่อส่งเสริมการบรรลุผลลัพธ์การเรียนรู้ตามมาตรฐานคุณวุฒิระดับอุดมศึกษา<br/>ติดต่อสอบถามเพิ่มเติม <a href="https://www.facebook.com/profile.php?id=61594119507845"> เพจ Facebook: Kpru-Psf </a>
            </p>
          </MDBCol>
        
        </MDBRow>
      </MDBContainer>
      <div className="footer-copyright text-center py-3">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Copyright: <a href="https://www.kpru.ac.th/"> www.kpru.ac.th </a>
        </MDBContainer>
      </div>
    </MDBFooter>
            </>
        )
    }
}
